import { render, staticRenderFns } from "./card-basic-rivoneed.vue?vue&type=template&id=52c7f5d0&scoped=true&"
import script from "./card-basic-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-basic-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-basic-rivoneed.vue?vue&type=style&index=0&id=52c7f5d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7f5d0",
  null
  
)

export default component.exports